var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser60({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 55,
    viewBox: "0 0 61 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_5732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0825195,
    y: 0.0820312,
    width: 60.1976,
    height: 53.9623,
    rx: 26.9811,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0825,
    y: 10.082,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFCB14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -14.9175,
    y: 40.082,
    width: 90,
    height: 90,
    rx: 45,
    fill: "#FFCB14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_5732"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0825195,
    y: 0.0820312,
    width: 60.1976,
    height: 53.9623,
    rx: 26.9811,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser60);
export default __webpack_public_path__ + "static/media/User-60.1ea6b7dbd9fb4e6ce3b4ed7d6e4ab14a.svg";
export { ForwardRef as ReactComponent };